import { axiosClient } from "@/axiosConfig";
import { promptsEndpoints } from "@/endpoints";
import { DEFAULT_DIMENSIONS } from "@/pages/dashboard/prompts/constants/prompts";
import { CreatePromptData, Prompt, PromptsListResponse, UpdatePromptData } from "@/types/prompts.types";

// API Service class for Prompts
export class PromptsService {
    // Get all prompts
    static async getPrompts(): Promise<PromptsListResponse> {
        const response = await axiosClient.get(promptsEndpoints.listPrompts);
        return response.data;
    }

    // Create a new prompt
    static async createPrompt(data: CreatePromptData): Promise<Prompt> {
        const response = await axiosClient.post(promptsEndpoints.createPrompt, data);
        return response.data;
    }

    // Update an existing prompt
    static async updatePrompt(id: string, data: UpdatePromptData): Promise<Prompt> {
        const response = await axiosClient.patch(promptsEndpoints.updatePrompt(id), data);
        return response.data;
    }

    // Delete a prompt (for future use)
    static async deletePrompt(id: string): Promise<void> {
        await axiosClient.delete(promptsEndpoints.deletePrompt(id));
    }

    // Get single prompt by ID (for future use)
    static async getPromptById(id: string): Promise<Prompt> {
        const response = await axiosClient.get(promptsEndpoints.getPromptById(id));
        return response.data;
    }
}

// Helper functions for form data preparation
export const prepareCreatePromptData = (formData: {
    name: string;
    prompt: string;
    tags: string[];
}): CreatePromptData => {
    return {
        name: formData.name,
        prompt: formData.prompt,
        tags: formData.tags,
        // Using default dimensions until form supports dimension selection
        dimensions: [...DEFAULT_DIMENSIONS],
    };
};

export const prepareUpdatePromptData = (formData: {
    name: string;
    prompt: string;
    tags: string[];
}): UpdatePromptData => {
    return {
        name: formData.name,
        prompt: formData.prompt,
        tags: formData.tags,
        // Using default dimensions until form supports dimension selection
        dimensions: [...DEFAULT_DIMENSIONS],
    };
};
